import { Button } from '@iwoca/orion';
import { useFormikContext } from 'formik';

import { Checkbox } from '../../../../Buyer/components/Checkbox/Checkbox';
import { Policy } from '../../../../Buyer/Signup/steps/DirectorInfo/Policy/Policy';
import { LoadingSpinner } from '../../../../components/LoadingSpinner/LoadingSpinner';
import { CrossSellFormValues } from '../../utils/CrossSellCard.types';

export const PrivacyPolicy = () => {
  const { values, isValid, isSubmitting } =
    useFormikContext<CrossSellFormValues>();

  return (
    <div>
      <div className="max-h-[350px] overflow-y-scroll bg-secondary-95 px-s">
        <Policy />
      </div>
      <Checkbox
        disabled={isSubmitting}
        name="policyAgreed"
        labelText="I'm happy with this"
        className="my-l"
      />
      <Button
        defaultChecked={values.policyAgreed}
        disabled={!isValid || isSubmitting}
        className="w-full"
      >
        {isSubmitting ? (
          <>
            <div className="mr-s">Submitting...</div>
            <LoadingSpinner />
          </>
        ) : (
          'Submit Application'
        )}
      </Button>
    </div>
  );
};
